export class GetDataCatalogSemanticLayerArtifactResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "document",
            "baseName": "document",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogSemanticLayerArtifactResponse.attributeTypeMap;
    }
    constructor() {
    }
}
